import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import React, { useEffect, useState, Suspense } from "react";

window.addEventListener('vite:preloadError', (event) => {
  console.log(event);
  console.warn('new version found.  reloading...');
  window.location.reload();
});

interface ErrorBoundaryProps {
	children: React.ReactNode;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
	const [hasError, setHasError] = useState(false);

	React.useEffect(() => {
		const handleError = (event: ErrorEvent) => {
			setHasError(true);  
		};
		window.addEventListener("error", handleError);
		return () => window.removeEventListener("error", handleError);
	}, []);

    if (hasError) {
      return <UpdateRequired />;
    } else {
      return <>{children}</>;
    }
};

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const App = () => {
	return <ErrorBoundary>
	  <Suspense fallback={<div>Loading...</div>}>
	    <RouterProvider router={router} />
	  </Suspense>
	</ErrorBoundary>;
};

const UpdateRequired = () => {
  useEffect(() => {
    // setTimeout(() => {
    //   window.location.reload();
    // }, 2000);
  }, []);

	return (
		<div className="flex h-screen items-center justify-center bg-orange-500 px-6 text-white">
			<div className="text-center">
				<div className="flex items-center justify-center">
					<div className="mb-5 text-2xl font-bold">PhilTrade</div>
				</div>
				<h1 className="text-4xl font-bold md:text-6xl mb-4">This page has been updated. </h1>
				<h1 className="mb-4 text-2xl font-bold">Reloading to the latest version.</h1>
			</div>
		</div>
	);
};

export default App;
